import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";

const isProduction =
  import.meta.env.PROD &&
  import.meta.env.MODE === "production" &&
  typeof window !== "undefined" &&
  !window.location.hostname.includes("stage") &&
  !window.location.hostname.includes("localhost") &&
  !window.location.hostname.includes("127.0.0.1") &&
  !window.location.hostname.endsWith(".pages.dev");

Sentry.init({
  dsn: "https://53ccb4d448e41bf483ad1a6ac11e36b3@o4510890079289344.ingest.de.sentry.io/4510890082959440",
  enabled: isProduction,
  environment: import.meta.env.MODE,
  sendDefaultPii: isProduction,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  tracePropagationTargets: [
    "localhost",
    "api-local.ryncast.com",
    /^https:\/\/api\.ryncast\.com/,
    /^https:\/\/stage-api\.ryncast\.com/,
  ],
  replaysSessionSampleRate: isProduction ? 0.05 : 0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
